// extracted by mini-css-extract-plugin
module.exports = {"reviews":"reviews_reviews__MXGRG","spinner":"reviews_spinner__21hEz","loadMoreButton":"reviews_loadMoreButton__18ej-"};